import { useCallback, useEffect, useRef } from "react";
import { formatDate } from "../../utils/common";

function DonationListMobile({
  data,
  totalCount,
  currentPage,
  pageSize,
  onPageChange,
  cancel,
  renderStatus,
}) {
  const loader = useRef(null);
  const hasMore = data.length < totalCount;

  const observerCallback = useCallback(
    (entries) => {
      const target = entries[0];
      if (target.isIntersecting && hasMore) {
        onPageChange(currentPage + 1);
      }
    },
    [currentPage, hasMore, onPageChange]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 1.0,
    });

    const currentLoader = loader.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [observerCallback]);

  return (
    <>
      <ul className="product-list-mobile">
        {data.map((item, i) => {
          return (
            <li className="box" key={i}>
              <dl>
                <dt>상품명</dt>
                <dd>
                  <span>
                    {item.billingSubscriptionsSeq ? "정기후원" : "일반결제"}
                  </span>
                </dd>
              </dl>
              <dl>
                <dt>결제일</dt>
                <dd>{formatDate(item.regDate)}</dd>
              </dl>
              <dl>
                <dt>금액</dt>
                <dd>{Number(item.amount).toLocaleString()}원</dd>
              </dl>
              <dl>
                <dt>결제 유형</dt>
                <dd>
                  {item.billingSubscriptionsSeq ? (
                    <span className="not-use">정기결제</span>
                  ) : (
                    <span className="success-use">일반결제</span>
                  )}
                </dd>
              </dl>
              <div>
                {item.billingSubscriptionsSeq &&
                  renderStatus(
                    item.isDonationSubscriptionActive,
                    item.billingSubscriptionsSeq
                  )}
              </div>
            </li>
          );
        })}
      </ul>
      {hasMore && <div ref={loader} style={{ height: "30px" }} />}
    </>
  );
}

export default DonationListMobile;
